export default {
  name: { id: 'name' },
  sites: { id: 'sites' },
  visibleInUi: { id: 'visible_in_ui' },
  saveInfo: { id: 'save_info' },
  siteGroup: { id: 'site_group' },
  siteGroups: { id: 'site_groups' },
  siteGroupList: { id: 'site_group_list' },
  siteGroupInfo: { id: 'site_group_info' },
  createSiteGroup: { id: 'create_site_group' },
  editSiteGroup: { id: 'edit_site_group' },
  deleteSiteGroup: { id: 'delete_site_group' },
  deleteSiteGroupMessage: { id: 'delete_site_group_message' },
}
